import * as React from 'react';
import autobind from 'autobind-decorator';
import Icon from '__common/components/Icon';
import { changeAttachment, changeFlashingAttachment } from 'bom/components/utils/partsSelectionFunctions';
import SelectionControlGroup from 'react-md/lib/SelectionControls/SelectionControlGroup';
import { find } from 'lodash';
import { state } from '__common/store';
import SelectionControl from 'react-md/lib/SelectionControls/SelectionControl';
import { applyQ4MplDiscontinuedParts } from '__common/utils/versionCompare/versionCompare';
export default class Attachments extends React.Component<attachmentsComponentState, {}> {
  @autobind
  changeAttachment(attachment: string) {
    const { attachmentGroup, attachments } = this.props;
    changeAttachment(attachment, attachmentGroup, attachments);
  }

  @autobind
  changeFlashingAttachment(value: string, event: any) {
    const { attachmentGroup, attachments } = this.props;
    const clicked = event.target.value;
    changeFlashingAttachment(clicked, attachmentGroup, attachments);
  }

  parseAttachments(attachments: bomPartsList) {
    return attachments.map(attachment => ({ label: attachment.name, value: attachment.number || '' }));
  }

  hideAttachments(attachments: { label: string, value: string }[]) {
    const selectedAttachments = state().bom.selectedAttachmentType;
    const projectVersion = state().projectConfiguration.projectVersion;
    let filteredAttachments = attachments;

    if (applyQ4MplDiscontinuedParts(projectVersion)) {
      filteredAttachments = filteredAttachments.filter(attachment => attachment.value !== '004FLCT');
    }

    if (selectedAttachments && selectedAttachments['tile hooks']) {
      const tileHookSpanishCT1 = find(selectedAttachments['tile hooks'], hook => hook.number === '004CT1S');

      if (tileHookSpanishCT1 && !tileHookSpanishCT1.selected) {
        return filteredAttachments.filter(attachment => attachment.value !== '004FLCT');
      }
    }

    return filteredAttachments;
  }

  getSelectedPartNumber(attachments: bomPartsList) {
    const selected = attachments.filter(attachment => attachment.selected);
    return selected.length ? selected[0].number : '';
  }
getSelectedPartNumbers(attachments) {
  const selections = state().bom.extraParameters?.selections;

  if (selections?.flashings?.length) {
    return selections.flashings;
  }

  return [''];
}

  render() {
    const { attachments, attachmentGroup } = this.props;
    const parsedAttachments = this.parseAttachments(attachments);
    const readyAttachments = this.hideAttachments(parsedAttachments);
    const getSelectedPartNumber = this.getSelectedPartNumber(attachments);

    return (
      <div className="attachment-types-selector">
        <div className="control-panel-sublabel">
          {attachmentGroup.toUpperCase()}
        </div>
        {attachmentGroup !== 'flashings' && (
          <SelectionControlGroup
            id={`attachments-selection-control-group-radios-${attachmentGroup}`}
            name={`attachments-${attachmentGroup}`}
            type="radio"
            value={getSelectedPartNumber === 'None' ? '' : getSelectedPartNumber}
            controls={readyAttachments}
            onChange={this.changeAttachment}
            checkedRadioIcon={<Icon>check</Icon>}
            uncheckedRadioIcon={<Icon>check</Icon>}
            inline={true}
          />
        )}

        {attachmentGroup === 'flashings' && readyAttachments.map((attachment, index) => {
          const selectedPartNumbers = this.getSelectedPartNumbers(attachments);
          const isChecked = selectedPartNumbers.includes(attachment.value);

          return (
            <SelectionControl
              key={attachment.value || index}
              id={`flashing-${attachmentGroup}-${attachment.value}`}
              label={attachment.label}
              value={attachment.value}
              type="checkbox"
              checked={isChecked}
              onChange={() => this.changeFlashingAttachment(attachment.value, { target: { value: attachment.value } })}
              inline={true}
              checkedCheckboxIcon={<Icon>check</Icon>}
              uncheckedCheckboxIcon={<Icon>check</Icon>}
            />
          );
        })}
      </div>
    );
  }
}

